import { ServiceCommand } from '../../../../../core/domain/command/service-command';
import { authHttpClient } from '../../../../../core/infra/http/axios-auth-http-client-adapter';
import { AUTH_API_ROUTES } from '../../api/routes';
import { SelfOnboarding } from './self-onboarding';

export const selfOnboardingService: ServiceCommand<SelfOnboarding.Response> =
  new SelfOnboarding(authHttpClient, AUTH_API_ROUTES.SELF_ONBOARDING);

export type { SelfOnboarding };
